import styled from 'styled-components';

export const StyledCloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: transparent;
  cursor: pointer;
  border: none;
  z-index: 1;
`;
